import { navigate } from './api';
import type { OneliveGnbMenuItem } from './oneliveGnbMenu';
import { ONELIVE_GNB_MENU } from './oneliveGnbMenu';
import { LOGIN_GATE_PATHS } from './authRedirect';
import { handleLoginRequired } from './liveEntryGuard';
import { useLiveUiMessages } from './useLiveUiMessages';
import { useOneliveSession } from './useOneliveSession';

interface OneliveGnbNavMenuProps {
  className?: string;
  onNavigate?: () => void;
  items?: OneliveGnbMenuItem[];
}

export default function OneliveGnbNavMenu({
  className = '',
  onNavigate,
  items = ONELIVE_GNB_MENU,
}: OneliveGnbNavMenuProps) {
  const liveUiMessages = useLiveUiMessages();
  const { isAuthed, authReady } = useOneliveSession();

  const onNavClick = (item: OneliveGnbMenuItem) => {
    if (authReady && !isAuthed && LOGIN_GATE_PATHS.has(item.path)) {
      handleLoginRequired(liveUiMessages, item.path);
      return;
    }
    navigate(item.path);
    onNavigate?.();
  };

  return (
    <ul className={`onelive-gnb-menu ${className}`.trim()}>
      {items.map((item) => (
        <li key={item.path}>
          <a
            href={item.path}
            onClick={(e) => {
              e.preventDefault();
              onNavClick(item);
            }}
          >
            <img src={item.icon} alt="" className="onelive-gnb-menu-icon" />
            <span className="onelive-gnb-menu-label">{item.label}</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
